import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VDialog, {
    style: {
      zIndex: _vm.options.zIndex
    },
    attrs: {
      persistent: "",
      fullscreen: ""
    },
    on: {
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
        return _vm.close.apply(null, arguments);
      }
    },
    model: {
      value: _vm.shown,
      callback: function callback($$v) {
        _vm.shown = $$v;
      },
      expression: "shown"
    }
  }, [_c(VCard, {
    staticClass: "card"
  }, [_c("div", {
    staticClass: "dialog-closer --t-2"
  }, [_c(VIcon, {
    staticClass: "far fa-times-circle",
    on: {
      click: function click($event) {
        return _vm.close();
      }
    }
  })], 1), _c(VCardTitle, [_c("span", {
    staticClass: "text-h5"
  }, [_vm._v(_vm._s(_vm.modal.title))])]), _c("div", {
    staticClass: "content-centered large"
  }, [_c("AssociateWineList", {
    key: _vm.associateWineListKey,
    attrs: {
      wineFiltersStorageKey: _vm.wineFiltersStorageKey,
      loggedUserData: _vm.loggedUserData,
      filtersVisibility: _vm.filtersVisibility,
      userTargetId: _vm.userTargetId,
      searchWine: _vm.wine.wineSupplierPrice.nameForProductLink,
      wineCard: _vm.wineCard,
      thirdPartyUserSelector: _vm.thirdPartyUserSelector
    },
    on: {
      associateWine: _vm.associateWine,
      associateCloneWine: _vm.associateCloneWine
    }
  })], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };